module.exports = __webpack_public_path__ + "img/google-play-badge-pl.efa20567.png";